export default "__VITE_ASSET__Dzoeu3$i__"